<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm label-width="0" inline class="elementui-common-form-styles" v-highlight @submit.native.prevent>
        <ElFormItem>
          <ElInput v-model="keyword" placeholder="媒体ID / 媒体名称" :maxlength="50" @change="search">
            <i slot="append" @click="search" class="el-icon-search"></i>
          </ElInput>
        </ElFormItem>
        <ElFormItem class="bg-transparent">
          <ElButton type="primary" @click="newMedia">新建媒体</ElButton>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import { isEmpty, trim } from '@/common/js/utils'
export default {
  name: 'MediaFilter',
  props: {
    loading: {
      type: Boolean
    },
    queryKey: {
      type: String
    }
  },
  data() {
    return {
      keyword: ''
    }
  },
  mounted() {
    this.keyword = this.queryKey
  },
  methods: {
    search() {
      const params = {
        keyword: isEmpty(this.keyword) ? undefined : trim(this.keyword),
        opId: this.opId === '' ? undefined : this.opId
      }
      this.$emit('on-search', params)
    },
    newMedia() {
      this.$emit('on-add')
    },
    setQueryKey(queryKey) {
      this.keyword = queryKey
    }
  }
}
</script>
